module.exports = __webpack_public_path__ + "static/media/Vector.be7a053b.svg";